import React from 'react';
import { Button, Input } from 'antd';
import { ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';

interface BuilderToolbarProps {
  /** Called when the back button is clicked. */
  onBack?: () => void;
  /** Override the back button label. Default: "Back". */
  backLabel?: string;
  /** Primary entity name (e.g. template name, protocol name). */
  name: string;
  onNameChange: (value: string) => void;
  namePlaceholder?: string;
  /** Short description field shown next to the name. */
  description: string;
  onDescriptionChange: (value: string) => void;
  /** Additional controls to render between description and the save button
   *  (e.g. category select, version input, active toggle). */
  extraSlot?: React.ReactNode;
  onSave: () => void;
  saving?: boolean;
  /** Override the save button label. Default: "Save". */
  saveLabel?: string;
}

/**
 * BuilderToolbar — the horizontal top bar shared by all flow builders.
 * Renders: [Back] [Name] [Description] [extraSlot] [ml:auto Save]
 *
 * Place inside BuilderLayout's `toolbar` prop (already inside a flex row).
 */
const BuilderToolbar: React.FC<BuilderToolbarProps> = ({
  onBack,
  backLabel = 'Back',
  name,
  onNameChange,
  namePlaceholder = 'Name...',
  description,
  onDescriptionChange,
  extraSlot,
  onSave,
  saving = false,
  saveLabel = 'Save',
}) => {
  return (
    <>
      {onBack && (
        <Button icon={<ArrowLeftOutlined />} onClick={onBack}>
          {backLabel}
        </Button>
      )}

      <Input
        value={name}
        onChange={(e) => onNameChange(e.target.value)}
        placeholder={namePlaceholder}
        style={{ width: 220, fontWeight: 600 }}
      />

      <Input
        value={description}
        onChange={(e) => onDescriptionChange(e.target.value)}
        placeholder="Description (optional)"
        style={{ width: 240 }}
      />

      {extraSlot}

      <div style={{ marginLeft: 'auto' }}>
        <Button
          type="primary"
          icon={<SaveOutlined />}
          loading={saving}
          onClick={onSave}
        >
          {saveLabel}
        </Button>
      </div>
    </>
  );
};

export default BuilderToolbar;
